module.exports = "/assets/logo_sg_adobestock-62fea4850c4fe5b98b882b79abd93b10.png";